import React, { useEffect, useState } from 'react';

import { Radio } from '@mui/material';
import dayjs from 'dayjs';
import { Row, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { Button } from '../../../components';
import { getStates } from '../../DriverQualification/ListDQ/NewRequest/operations';
import { generateReport, generateSingleReport, getReportData, removeReportData, getList } from '../operations';
import { customStyles } from '../utils';

import './styles.scoped.css';

const CheckPDFForm = ({ setForm, form, setLoadingResults, isCustomer, setData, setShowResults, setIsCustomer }) => {
  const navigate = useNavigate();
  const [clientStatuses, setClientStatuses] = useState([]);
  const [lines, setLines] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);

  useEffect(() => {
    getList('client-status').then(res => {
      const statuses = res.map(({ REF_CODE, REF_DESCRIPTION }) => ({
        label: REF_DESCRIPTION,
        value: REF_CODE,
      }));
      setClientStatuses(statuses);
    });
    getList('line-of-business').then(res => {
      const newLines = res.map(({ LineOfBusinessCode, LineOfBusinessDesc }) => ({
        label: LineOfBusinessDesc,
        value: LineOfBusinessCode,
      }));
      setLines(newLines);
    });
    getAndSetFormData();
  }, []);

  const getAndSetFormData = async () => {
    const states = await getStates();
    if (states) {
      setStateOptions(
        states
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map(({ name, id }) => ({
            label: name,
            value: id,
          })),
      );
    }
  };

  const handleViewResults = async () => {
    if (
      !(
        dayjs(form?.ToPerEnddate).isAfter(form?.FromPerEnddate) ||
        dayjs(form?.FromPerEnddate).isSame(form?.ToPerEnddate)
      )
    ) {
      alert('Invalid date range. Please double check and try again.');
      return;
    }
    setLoadingResults(true);
    const {
      FromPerEnddate = '',
      ToPerEnddate = '',
      Status = '',
      LineOfBusiness = '',
      BillToNumber = 0,
      AMC = '',
      City = '',
      State = '',
      CustomerNumber = 0,
      CustomerName = '',
      invoiceId = 0,
    } = form;
    try {
      const response = isCustomer
        ? await generateReport({
            endpoint: 'invoice-report-client',
            payload: {
              FromPerEnddate,
              ToPerEnddate,
              Status,
              LineOfBusiness,
              BillToNumber: parseInt(BillToNumber),
              AMC,
              City,
              State,
              CustomerNumber: parseInt(CustomerNumber),
              CustomerName,
            },
          })
        : await generateSingleReport({
            endpoint: `invoice-report-invoice-number?invoiceId=${invoiceId}`,
          });

      if (response.location && response.location !== '') {
        const reportData = await getReportData(response.location);
        if (reportData?.length) {
          await removeReportData(response.location);
          setLoadingResults(false);
          setData(reportData);
          setShowResults(true);
        }
      } else if (response.length === 0) {
        alert('No data found');
        setLoadingResults(false);
      } else {
        setLoadingResults(false);
        if (response.statusCode !== 404) {
          setData(response);
          setShowResults(true);
        } else {
          setLoadingResults(false);
          alert('No data found matching your criteria.');
        }
      }
    } catch (error) {
      console.log(error);
      setLoadingResults(false);
    }
  };

  const handleChange = e => {
    const _form = { ...form, [e.target.name]: e.target.value };
    setForm(_form);
  };

  const handleFormSubmit = e => {
    e.preventDefault();
    handleViewResults();
  };

  return (
    <Form
      noValidate
      onSubmit={handleFormSubmit}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <p style={{ marginTop: '20px' }}>Select to search by Customer Info or Invoice Number</p>
      <span>
        <span className="radio-group">
          <Radio
            style={{
              transform: 'scale(1)',
            }}
            className="radio-button"
            onChange={() => setIsCustomer(true)}
            checked={isCustomer}
          />
          <span>Customer Info</span>
        </span>
        <span className="radio-group">
          <Radio
            style={{
              transform: 'scale(1)',
              marginLeft: 50,
            }}
            className="radio-button"
            onChange={() => setIsCustomer(false)}
            checked={!isCustomer}
          />
          <span>Invoice Number</span>
        </span>
      </span>
      {isCustomer ? (
        <div className="filters-row">
          <div className="filter-row">
            <Form.Group as={Row} controlId="Status" style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>Customer Status</Form.Label>
              <div className="dropdown-spinner-container">
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  styles={customStyles('860px')}
                  options={clientStatuses}
                  isClearable
                  onChange={selectedOptions => {
                    const selectedCodes = selectedOptions.map(option => option.value);
                    setForm({
                      ...form,
                      Status: selectedCodes.join(','),
                    });
                  }}
                  value={form?.EmpStatus?.split(',').map(code => clientStatuses.find(option => option.value === code))}
                />
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  aria-hidden="true"
                  className="dropdown-spinner"
                  hidden
                />
              </div>
            </Form.Group>
          </div>
          <div className="filter-row">
            <Form.Group as={Row} controlId="EmpStatus" style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>Line Of Business</Form.Label>
              <div className="dropdown-spinner-container">
                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  styles={customStyles('860px')}
                  options={lines}
                  isClearable
                  onChange={selectedOptions => {
                    const selectedLines = selectedOptions.map(option => option.value);
                    setForm({
                      ...form,
                      LineOfBusiness: selectedLines.join(','),
                    });
                  }}
                  value={form?.LineOfBusiness?.split(',').map(line => lines.find(option => option?.value === line))}
                />
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  aria-hidden="true"
                  className="dropdown-spinner"
                  hidden
                />
              </div>
            </Form.Group>
          </div>
          <div className="filter-row">
            <Form.Group as={Row} controlId="BillToNumber" style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>Bill To Number</Form.Label>
              <Form.Control
                style={{
                  width: '360px',
                  height: '30px',
                  marginRight: '20px',
                }}
                as="input"
                name="BillToNumber"
                value={form?.BillToNumber}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group as={Row} controlId="AMC" style={{ alignItems: 'center' }}>
              <Form.Label
                style={{
                  width: 120,
                  marginLeft: 90,
                }}>
                AMC Code
              </Form.Label>
              <Form.Control
                style={{
                  width: '300px',
                  height: '30px',
                }}
                as="input"
                name="AMC"
                value={form?.AMC}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
          <div
            className="filter-row"
            style={{
              alignItems: 'flex-start',
              marginTop: 30,
              gap: 12,
              paddingLeft: 0,
            }}>
            <Form.Group controlId="FromPerEnddate" style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
              <Form.Label style={{ width: 278, marginTop: 6 }}>Week Ending Date</Form.Label>
              <Form.Control
                style={{ width: 150 }}
                as="input"
                type="date"
                name="FromPerEnddate"
                value={form?.FromPerEnddate}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId="FromPerEnddate" style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
              <Form.Label style={{ marginTop: 6 }}>To</Form.Label>
              <Form.Control
                as="input"
                type="date"
                name="ToPerEnddate"
                value={form?.ToPerEnddate}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group controlId="locationState" style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
              <Form.Label style={{ marginLeft: 74, width: 108, marginTop: 6 }}>State</Form.Label>
              <Form.Group>
                <div className="dropdown-spinner-container">
                  <Select
                    name="State"
                    isClearable
                    styles={customStyles('300px')}
                    options={stateOptions}
                    onChange={e => {
                      const _form = { ...form, State: e?.value || '' };
                      setForm(_form);
                    }}
                    value={stateOptions?.filter(state => state?.value === form?.State)}
                  />
                </div>
              </Form.Group>
            </Form.Group>
            <Form.Group controlId="City" style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
              <Form.Label style={{ marginTop: 6 }}>City</Form.Label>
              <Form.Control
                style={{
                  marginTop: 4,
                  width: 300,
                  height: 30,
                }}
                as="input"
                name="City"
                value={form?.City}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
          <div className="filter-row">
            <Form.Group as={Row} style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>Customer Name</Form.Label>
              <Form.Control
                style={{
                  width: 360,
                  height: 30,
                  marginRight: 20,
                }}
                as="input"
                name="CustomerName"
                value={form?.CustomerName}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
          <div className="filter-row">
            <Form.Group as={Row} style={{ alignItems: 'center' }}>
              <Form.Label style={{ width: '290px' }}>Customer Number</Form.Label>
              <Form.Control
                style={{
                  width: '360px',
                  height: '30px',
                  marginRight: '20px',
                }}
                type="number"
                as="input"
                name="CustomerNumber"
                value={form?.CustomerNumber}
                onChange={handleChange}
              />
            </Form.Group>
          </div>
        </div>
      ) : (
        <div className="filter-row">
          <Form.Group as={Row} controlId="invoiceId" style={{ alignItems: 'center' }}>
            <Form.Label style={{ width: '100px' }}>Invoice #</Form.Label>
            <Form.Control
              style={{
                width: '360px',
                height: '30px',
                marginRight: '20px',
              }}
              as="input"
              type="number"
              name="invoiceId"
              value={form?.invoiceId}
              onChange={handleChange}
            />
          </Form.Group>
        </div>
      )}
      <div className="buttons-row">
        <Button variant="primary" onPress={handleViewResults} style={{ marginRight: '20px', width: '100px' }} text="View" />

        <Button
          style={{ width: '100px' }}
          onClick={() => navigate('/edge-reporting')}
          variant="outline"
          text="Cancel"
        />
      </div>
    </Form>
  );
};

export default CheckPDFForm;
